import { render, staticRenderFns } from "./month-board.vue?vue&type=template&id=5e336c13&"
import script from "./month-board.vue?vue&type=script&lang=js&"
export * from "./month-board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports